import script from "./Detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./Detail.vue?vue&type=script&lang=ts&setup=true"

import "./Detail.vue?vue&type=style&index=0&id=86f40df4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86f40df4"]])

export default __exports__